import { render } from "./ConfigSection.vue?vue&type=template&id=6e2402f0&scoped=true"
import script from "./ConfigSection.vue?vue&type=script&lang=js"
export * from "./ConfigSection.vue?vue&type=script&lang=js"

import "./ConfigSection.vue?vue&type=style&index=0&id=6e2402f0&lang=css"
import "./ConfigSection.vue?vue&type=style&index=1&id=6e2402f0&scoped=true&lang=css"
/* custom blocks */
import block0 from "./ConfigSection.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/Users/shaohuanqing/dev/kuboard-spray/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e2402f0"]])

export default __exports__